<template>
  <div class="app-dashboard">
    <vs-popup
      :title="(input_task.id ? 'Modifier une' : 'Nouvelle') + ' tâche'"
      accept-text="Ajouter"
      button-cancel="border"
      :buttons-hidden="true"
      @accept="submitForm"
      cancel-text="Annuler"
      :active.sync="activePrompt">
      <form>
        <div class="vx-row">
          <div class="vx-col ml-auto flex">
            <feather-icon icon="StarIcon" class="cursor-pointer" svgClasses="w-5 h-5"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              @keyup="changeverifier('title')"
              :danger="input_task_error.title"
              :danger-text="input_task_error.title ? 'Le titre de la tâche est réquis.' : ''"
              name="Nom" label="Tâche *" class="w-full mb-4 mt-5" placeholder="Tâche *" v-model="input_task.title"/>
          </div>
          <div class="vx-col w-full">
            <vs-textarea
              @keyup="changeverifier('content')"
              :class="input_task_error.content ? 'ccmt' : ''"
              label="Description *" v-model="input_task.content"/>
            <p class="span-text-validation" v-if="input_task_error.content"
               :style="(!input_task_error.content) ? '' : 'color:red; margin-top: -18px; margin-bottom: 20px'"> Le
              contenu de la tâche est réquis. </p>
          </div>
        </div>
      </form>

      <div style="margin-bottom: 10px !important;">
        <vs-button class="mr-6" @click="submitForm" :disabled="!isFormValid"> {{ input_task.id ? 'Modifier' : 'Ajouter'
          }}
        </vs-button>
        <vs-button type="border" color="danger" @click="activePrompt = false, initValues()">Annuler</vs-button>
      </div>
    </vs-popup>

    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">
            <div class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between">
              <div>
                <h2 class="mb-1 font-bold">{{stats.totalAssign}}</h2>
                <span class="font-medium">Requêtes assignées</span>

                <!-- <p class="mt-2 text-xl font-medium">
                                   <span class="text-success">
                                     <span>+</span>
                                     <span>20%</span>
                                   </span>
                   <span> ces 7 derniers jours </span>
                 </p>-->
              </div>
              <!-- <vs-button icon-pack="feather" icon="icon-chevrons-right" icon-after
                          class="shadow-md w-full lg:mt-0 mt-4">Voir Les Détails
               </vs-button>-->
            </div>

            <div
              class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
              <small class="text-right">
                <!--<span>Année 2020</span>-->
              </small>
              <vue-apex-charts
                v-if="requestsData.series[0].data.length"
                type=bar
                height=200
                :options="requestsData.chartOptions"
                :series="requestsData.series"/>
            </div>
          </div>
          <vs-divider class="my-6"/>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-3">
              <!--<p>Demandes clôturées: {{stats.totalEnd}}</p>-->
              <p>Demandes traitées: {{stats.totalTreat}}</p>
              <vs-progress class="block mt-1" :percent="stats.totalTreat" color="primary"/>
            </div>
            <div class="vx-col w-1/2 mb-3">
              <p>En cours de traitement: {{stats.totalOnTreat}}</p>
              <vs-progress class="block mt-1" :percent="stats.totalOnTreat" color="primary"/>
            </div>
            <div class="vx-col w-full mb-3">
              <p>Temps moyen de traitement: {{stats.averageProcessingTime}} min</p>
              <p class="text-grey">Moyenne générale : {{stats.overallAverage}} min</p>
              <vs-progress class="block mt-1" :percent="stats.overallAverage" color="primary"/>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="Demandes en cours de traitement par priorité">
          <template slot="no-body">
            <div style="height: 354px">
              <template slot="actions">
                <small><span>Derniers 30 jours</span></small>
              </template>

              <div slot="no-body" v-if="!loading">
                <!-- CHART -->
                <vue-apex-charts
                  type=pie height=234
                  class=""
                  :options="priorityCharts.options"
                  :series="priorityCharts.series"/>

                <ul class="mb-1">
                  <li
                    class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                                         <span class="flex items-center">
                                             <span class="inline-block h-3 w-3 rounded-full mr-2 bg-danger"/>
                                             <span class="font-semibold">Haute</span>
                                         </span>
                  </li>
                  <li
                    class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                                         <span class="flex items-center">
                                             <span class="inline-block h-3 w-3 rounded-full mr-2 bg-primary"/>
                                             <span class="font-semibold">Moyenne</span>
                                         </span>
                  </li>
                  <li
                    class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                                         <span class="flex items-center">
                                             <span class="inline-block h-3 w-3 rounded-full mr-2 bg-success"/>
                                             <span class="font-semibold">Basse</span>
                                         </span>
                  </li>
                </ul>

              </div>
            </div>
          </template>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-2/3 mb-base">
        <vx-card title="Temps de traitement des demandes">

          <template slot="actions">
            <small><span>7 dernières demandes clôturées</span></small>
          </template>

          <div slot="no-body" class="p-6 pb-0">
            <div class="flex">
              <div class="mr-6">
                <p class="mb-1 font-semibold">Temps moyen réél</p>
                <p class="text-3xl">{{real_average_time}} min</p>
              </div>
              <div>
                <p class="mb-1 font-semibold">Temps moyen recommandé</p>
                <p class="text-3xl">{{recommended_average_time}} min</p>
              </div>
            </div>

            <vue-apex-charts
              v-if="timeCharts.options.xaxis.categories.length && timeCharts.series[0].data.length && timeCharts.series[1].data.length"
              type="area"
              height="420"
              :options="timeCharts.options"
              :series="timeCharts.series"/>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="Activity Log">
          <vx-timeline :data="timelineData"/>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Dernières demandes">

          <template slot="actions">
            <!--<vs-button color="primary" type="flat">Demandes non assignées</vs-button>-->
          </template>

          <div slot="no-body" class="mt-4">
            <vs-table :data="notAssignedRequests" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>DEMANDE</vs-th>
                <vs-th>TYPE</vs-th>
                <vs-th>PRIORITÉ</vs-th>
                <vs-th>STATUT</vs-th>
                <vs-th>DATE DE CREATION</vs-th>
                <vs-th>ACTIONS</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>{{data[indextr].title}}</span>
                  </vs-td>
                  <vs-td><span>{{ tr.type }}</span></vs-td>
                  <vs-td>
                    <vs-chip :color="getPriorityColor(tr.priority)">{{ tr.priority }}</vs-chip>
                  </vs-td>
                  <vs-td>
                    <vs-chip>{{ tr.status }}</vs-chip>
                  </vs-td>
                  <vs-td><span>{{ tr.created_at }}</span></vs-td>
                  <vs-td>
                                        <span
                                          @click="requests_assign({ id: tr.id, user_id: $store.state.AppActiveUser.id })"
                                          class="flex cursor-pointer hover:text-primary">
                                            <feather-icon

                                              icon="PlusCircleIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                            /> S'auto-assigner
                                        </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>

    <br>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Demandes dont le SLA arrive à terme">
          <div slot="no-body" class="mt-4">
            <vs-table :data="slaEndRequests" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>N°</vs-th>
                <vs-th>DEMANDE</vs-th>
                <vs-th>TYPE</vs-th>
                <vs-th>PRIORITÉ</vs-th>
                <vs-th>STATUT</vs-th>
                <vs-th>DATE DE CREATION</vs-th>
                <vs-th>ACTIONS</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>{{data[indextr].ref}}</span>
                  </vs-td>
                  <vs-td>
                    <span>{{data[indextr].title}}</span>
                  </vs-td>
                  <vs-td><span>{{ tr.type }}</span></vs-td>
                  <vs-td>
                    <vs-chip :color="getPriorityColor(tr.priority)">{{ tr.priority }}</vs-chip>
                  </vs-td>
                  <vs-td>
                    <vs-chip>{{ tr.status }}</vs-chip>
                  </vs-td>
                  <vs-td><span>{{ tr.created_at }}</span></vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <div class="flex">
                      <div @click="goToSingle(tr.id, tr.has_proved)" class="flex">
                        <feather-icon
                          icon="EyeIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          class="mr-2"
                        />
                        Détails
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>>

<script>
  var base_self;
  let input_tempon = {
    request_id: '',
    title: '',
    content: '',
  };
  let input_task_error_tempon = {
    title: false,
    content: false,
  };
  import VueApexCharts from 'vue-apexcharts';
  import VxTimeline from "../../../components/timeline/VxTimeline";

  export default {
    components: {VueApexCharts, VxTimeline},
    data() {
      return {
        stats: {
          averageProcessingTime: 0,
          overallAverage: 0,
          totalAssign: 0,
          totalEnd: 0,
          totalOnTreat: 0,
          totalTreat: 0
        },
        real_average_time: 0,
        recommended_average_time: 0,
        activePrompt: false,
        input_task_error: JSON.parse(JSON.stringify(input_task_error_tempon)),
        input_task: JSON.parse(JSON.stringify(input_tempon)),
        total: 0,
        completed: 0,
        requestsData: {
          chartOptions: {
            grid: {
              show: false,
              padding: {
                left: 0,
                right: 0
              }
            },
            chart: {
              type: 'bar',
              sparkline: {enabled: true},
              toolbar: {show: false},
            },
            states: {
              hover: {
                filter: 'none'
              }
            },
            colors: [
              'rgba(7, 122, 48, 0.35)',
              'rgba(7, 122, 48, 0.35)',
              '#055723',
              'rgba(7, 122, 48, 0.35)',
              'rgba(7, 122, 48, 0.35)',
              'rgba(7, 122, 48, 0.35)'
            ],
            plotOptions: {
              bar: {
                columnWidth: '45%',
                distributed: true,
                endingShape: 'rounded',
              }
            },
            tooltip: {
              x: {show: false}
            },
          },
          series: [{
            name: 'Nb demandes',
            data: [/* 75, 125, 225, 175, 125, 785, 25 */]
          }],
        },
        todoToday: [
          /* {
              id: 3,
              title: "Lorem ipsum dolor sit amet #456",
              content: "11 Fev 2019",
          },
          {
              id: 70,
              title: "Lorem ipsum dolor sit amet  #456",
              content: "14 Fev 2019",
          },
          {
              id: 8,
              title: "Lorem ipsum dolor sit amet  #456",
              content: "16 Fev 2019",
          },
          {
              id: 1,
              title: "Lorem ipsum dolor sit amet  #456",
              content: "20 Fev 2019",
          } */
        ],
        timeCharts: {
          options: {
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth'
            },
            // colors: themeColors,
            xaxis: {
              categories: [/* "Demannde 1", "Demande 2", "Demande 3",
                                "Demande 4", "Demannde 5", "Demande 6",
                                "Demande 7" */
              ],
            },
            tooltip: {
              x: {
                format: ''
              },

            }
          },
          series: [{
            name: 'Temps de traitement réél en min',
            data: [/* 100, 80, 130, 120, 130, 109, 100 */]
          }, {
            name: 'Temps de traitement recommandé en min',
            data: [/* 90, 100, 130, 90, 110, 95, 70 */]
          }]
        },
        timelineData: [
          /* {
              color: "primary",
              icon: "PlusIcon",
              title: "Client Meeting",
              desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
              time: "25 mins Ago"
          },
          {
              color: "warning",
              icon: "MailIcon",
              title: "Email Newsletter",
              desc: "Cupcake gummi bears soufflé caramels candy",
              time: "15 Days Ago"
          },
          {
              color: "danger",
              icon: "UsersIcon",
              title: "Plan Webinar",
              desc: "Candy ice cream cake. Halvah gummi bears",
              time: "20 days ago"
          },
          {
              color: "success",
              icon: "LayoutIcon",
              title: "Launch Website",
              desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.",
              time: "25 days ago"
          },
          {
              color: "primary",
              icon: "TvIcon",
              title: "Marketing",
              desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.",
              time: "28 days ago"
          } */
        ],
        notAssignedRequests: [
          /* {
              id: 1,
              title: 'Numéro désactivé sans raison',
              type: 'plainte',
              priority: 'high',
              status: 'En cours de traitemennt',
              created_at: '20/03/2020 11:23:03'
          },
          {
              id: 2,
              title: 'Résiliationn de notre contrat de flotte',
              type: 'Résiliation',
              priority: 'low',
              status: 'En cours d\'approbation',
              created_at: '19/03/2020 11:23:03'
          },
          {
              id: 3,
              title: 'Ajouter un nouveau membre à la flotte',
              type: 'Assistance',
              priority: 'medium',
              status: 'Clôturée',
              created_at: '19/03/2020 11:23:03'
          } */
        ],
        slaEndRequests: [],
        priorityCharts: {
          options: {
            labels: [],
            dataLabels: {
              enabled: false
            },
            legend: {show: false},
            chart: {
              type: 'pie',
              offsetY: 0,
              dropShadow: {
                enabled: false,
                blur: 5,
                left: 1,
                top: 1,
                opacity: 0.2
              },
              toolbar: {
                show: false
              }
            },
            stroke: {
              width: 5
            },
            colors: ['#EA5455', '#1E1E1E', '#29c76f'],
          },
          series: [0, 0, 0],
          // series: []
        },
        loading: false
      }
    },
    methods: {
      changeverifier(libelle) {
        if (!base_self.input_task[libelle].length) {
          base_self.input_task_error[libelle] = true;
        } else {
          base_self.input_task_error[libelle] = false;
        }
      },
      async submitForm() {
        //
        this.input_task.request_id = window.SingleRequestApp.$route.params.id

        let response;
        if (this.input_task.id) {
          response = await base_self.$store.state.requests_tasks_update(this.input_task);
          if (response.data.status) {
            window.GETCCMT.success('La tâche est modifiée avec succès.', response);

            this.initValues()
          } else {
            window.GETCCMT.error({message: 'La modification de la tâche a échouée.'});
          }
        } else {
          response = await base_self.$store.state.requests_tasks_create(this.input_task);
          if (response.data.status) {
            window.GETCCMT.success('La tâche est ajoutée avec succès.', response);

            this.initValues()
          } else {
            window.GETCCMT.error({message: 'L\'ajout de la tâche a échouée.'});
          }
        }

        window.SingleRequestApp.getRequests_detail_tasks(window.SingleRequestApp.$route.params.id);
      },
      closeCardAnimationDemo(card) {
        card.removeRefreshAnimation(2000);
      },
      todo_edit(item) {
        this.initValues()
        base_self.input_task = JSON.parse(JSON.stringify(item));
        base_self.activePrompt = true
      },
      initValues() {
        base_self.activePrompt = false;
        base_self.input_task = JSON.parse(JSON.stringify(input_tempon));
        base_self.input_task_error = JSON.parse(JSON.stringify(input_task_error_tempon));
      },
      async openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirmation',
          text: 'Confirmer la suppression?',
          acceptText: 'Confirmer',
          cancelText: 'Annuler',
          accept: async () => {
            let response = await base_self.$store.state.requests_tasks_delete({id});

            if (response.data.status) {
              window.GETCCMT.success('La tâche est supprimée avec succès.', response);
            } else {
              window.GETCCMT.error({message: 'La suppression de la tâche a échouée.'});
            }
            base_self.get_dashboard_charger_tasks();
          }
        })
      },
      async requests_assign(params) {
        let response = await base_self.$store.state.requests_assign(params);
        if (response.data.status) {
          window.GETCCMT.success('La demande est assignée avec succès.', response);
        } else {
          window.GETCCMT.error({message: 'L\'assignation de la demande a échouée.'});
        }
        base_self.get_dashboard_charger_request_not_assign();
      },
      async toggleis_important(id) {
        let response = await base_self.$store.state.requests_tasks_is_important({id});
        if (response.data.status) {
          window.GETCCMT.success('La tâche est modifiée avec succès.', response);
        } else {
          window.GETCCMT.error({message: 'La modification de la tâche a échouée.'});
        }
        base_self.get_dashboard_charger_tasks();
      },
      async toggleis_completed(id) {
        let response = await base_self.$store.state.requests_tasks_is_completed({id});
        if (response.data.status) {
          window.GETCCMT.success('La tâche est modifiée avec succès.', response);
        } else {
          window.GETCCMT.error({message: 'La modification de la tâche a échouée.'});
        }
        base_self.get_dashboard_charger_tasks();
      },
      getPriorityColor(status) {
        status = status.toLowerCase();
        if (status == "normale") return "primary";
        if (status == "basse") return "success";
        if (status == "haute") return "danger";
        return "primary";
      },
      async get_dashboard_charger_tasks() {
        let response = await base_self.$store.state.dashboard_charger_tasks({});

        base_self.todoToday = response.data.tasks;
        base_self.total = response.data.total;
        base_self.completed = response.data.completed;
        // console.log('dashboard_charger_tasks -- response.data: ', response.data);
      },
      async get_dashboard_charger_stats() {
        this.loading = true;
        this.$http.get('/dashboard/charger/request-in-progress-stats', {}).then(response => {
          if (response.data) {
            this.priorityCharts.options.labels = response.data.priorities;
            let series = response.data.graph[0].data;

            this.priorityCharts.series = JSON.parse(JSON.stringify(series));
            this.loading = false
            console.log(this.loading)
          }
        }).catch((error) => {
          (error.response.status === 401) ? window.GETCCMT.$router.push('/login') : console.log('error: ', error)
        });


        //console.log('dashboard_charger_tasks -- response.data: ', response.data);
      },
      async get_dashboard_charger_request_not_assign() {
        let response = await base_self.$store.state.dashboard_charger_request_not_assign({});

        base_self.notAssignedRequests = response.data;
      },
      async get_dashboard_charger_sla_end_request() {
        let response = await base_self.$store.state.get_dashboard_charger_sla_end_request({});

        base_self.slaEndRequests = response.data;
      },
      async get_dashboard_charger_activity_log() {
        let response = await base_self.$store.state.dashboard_charger_activity_log({});

        var array = response.data;
        var length = array.length;
        for (let iuoy = 0; iuoy < length; iuoy++) {
          array[iuoy].color = "primary";
          array[iuoy].icon = "CheckIcon";

          array[iuoy].desc = array[iuoy].content;
          array[iuoy].time = array[iuoy].created_at;
        }
        base_self.timelineData = array;
        /*
        content: "Demande créé par Aliyonou komi"
        created_at: "2020-04-13 16:28:23"
        id: 1
        title: "Demande créé"
        username: "Aliyonou komi"

        color: "primary",
        icon: "PlusIcon",

        title: "Client Meeting",
        desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
        time: "25 mins Ago"
        */
        // console.log('dashboard_charger_activity_log -- response.data: ', response.data);
      },
      async get_dashboard_charger_request_stats() {
        let response = await base_self.$store.state.dashboard_charger_request_stats({});

        base_self.stats.averageProcessingTime = response.data.averageProcessingTime;
        base_self.stats.overallAverage = response.data.overallAverage;
        base_self.stats.totalAssign = response.data.totalAssign;
        base_self.stats.totalEnd = response.data.totalEnd;
        base_self.stats.totalOnTreat = response.data.totalOnTreat;
        base_self.stats.totalTreat = response.data.totalTreat;
        // console.log('dashboard_charger_request_stats -- response.data: ', response.data);
      },
      async get_dashboard_charger_graph_week() {
        let response = await base_self.$store.state.dashboard_charger_graph_week({});

        base_self.requestsData.series[0].data = response.data;
        // console.log('dashboard_charger_graph_week -- response.data: ', response.data);
      },
      async get_dashboard_charger_graph_of_request() {
        let response = await base_self.$store.state.dashboard_charger_graph_of_request({});

        var actual_processing_time = [];
        var recommended_time = [];
        var request_title = [];

        base_self.real_average_time = response.data.real_average_time;
        base_self.recommended_average_time = response.data.recommended_average_time;

        var length = response.data.graph.length;
        for (let iuoy = 0; iuoy < length; iuoy++) {
          var item = response.data.graph[iuoy];

          actual_processing_time.push(item.actual_processing_time ? item.actual_processing_time : 0);
          recommended_time.push(item.recommended_time ? item.recommended_time : 0);
          request_title.push(item.request_title ? item.request_title : '');
        }

        base_self.timeCharts.options.xaxis.categories = JSON.parse(JSON.stringify(request_title));
        base_self.timeCharts.series[0].data = JSON.parse(JSON.stringify(actual_processing_time));
        base_self.timeCharts.series[1].data = JSON.parse(JSON.stringify(recommended_time));
        // console.log('base_self.timeCharts: ', base_self.timeCharts);

        /*
        graph: Array(1)
        0:
        actual_processing_time: null
        recommended_time: 4
        request_title: "lllllllllllll"
        __proto__: Object
        length: 1
        __proto__: Array(0)
        real_average_time: 0
        recommended_average_time: 4
        timeCharts.options.xaxis.categories =
        timeCharts.series[0].data =
        timeCharts.series[1].data =

        timeCharts: {
            options: {
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                // colors: themeColors,
                xaxis: {
                    categories: ["Demannde 1", "Demande 2", "Demande 3",
                        "Demande 4", "Demannde 5", "Demande 6",
                        "Demande 7"
                    ],
                },
                tooltip: {
                    x: {
                        format: ''
                    },

                }
            },
            series: [{
                name: 'Temps de traitement réél en min',
                data: [100, 80, 130, 120, 130, 109, 100]
            }, {
                name: 'Temps de traitement recommandé en min',
                data: [90, 100, 130, 90, 110, 95, 70]
            }]
        */


        // console.log('dashboard_charger_graph_of_request -- response.data: ', response.data);
      },
      goToSingle(id, el) {
        let t = el ? 1 : 2
        this.$router.push('/requests/' + id + '/detail/' + t)
      },
    },
    mounted() {
      //base_self.get_dashboard_charger_tasks();
      base_self.get_dashboard_charger_request_not_assign();
      base_self.get_dashboard_charger_activity_log();
      base_self.get_dashboard_charger_request_stats();
      base_self.get_dashboard_charger_graph_week();
      base_self.get_dashboard_charger_graph_of_request();
      base_self.get_dashboard_charger_sla_end_request();
      base_self.get_dashboard_charger_stats();
    },
    computed: {
      isFormValid() {
        var is_ok = true;

        if (!base_self.input_task.title.length) is_ok = false;
        if (!base_self.input_task.content.length) is_ok = false;

        return is_ok;
      }
    },
    created() {
      base_self = this;
      window.CCDashboardApp = this;
    }
  }

  /*
  Hello Désirée voici les corrections que tu dois faire
- L'image par défaut pour le client sur l'onglet des informations est trop grandes essaye de la réduire pour qu'elle corresponde à celle qu'on avait sur la maquette //
- Le tableau de bords du client/mandataire, celui du manager ne sont pas implémentée //
- Le bouton cloturée apparaît au niveau du client même quand le traitement de la demande n'est pas encore finis, il ne doit apparâitre que quand la demande a le statut traité //
- Sur le side bar les menu actifs sont statiques  pour la facturation et le paramétre retire les et actives le menu uniquement quand on y accéde ********
- L'onglet d'approbation est absent sur les détails d'une demande quand on est connectée en tant que manager, ///
- L'onglet chaîne d'approbation apparaît sur les détails d'une demande quand on est connectée en tant que chargée clientele même quand elle ne nécessite pas d'approbation, ce onglet ne doit apparaître que quand la demande nécessite une approbation ///
- Le bouton cloturée au niveau des détails d'une demande pour le client/mandataire n'effectue aucune action. PS: Le client et le mandataire doivent pouvoir cloturer leur demandes en disant s'il sont satisfait ou non. ///
   */
</script>

<style lang="scss">
  .tasks-today-container {
    .tasks-today__task {
      transition: background .15s ease-out;

      .tasks-today__actions {
        display: none;
      }

      &:hover {
        background: rgba(var(--vs-primary), .04);

        .tasks-today__actions {
          display: flex;
        }
      }
    }
  }
</style>
